"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTag = void 0;
var OrderTag;
(function (OrderTag) {
    OrderTag["RENEWAL"] = "renewal";
    OrderTag["CART"] = "cart";
    OrderTag["TRIAL"] = "trial";
    OrderTag["DROPS"] = "drops";
    OrderTag["LENSES"] = "lenses";
    OrderTag["BLG"] = "blg";
    OrderTag["OTP"] = "otp";
})(OrderTag = exports.OrderTag || (exports.OrderTag = {}));
